export const DEMO_SLIDER_DEFAULT_VALUE = 30;
export const DEMO_SLIDER_STEPS_VALUE = 9;

export const SLIDER_DEFAULT_PROPS = {
  max: 100, // @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#specifying_the_minimum_and_maximum
  min: 0, // @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#specifying_the_minimum_and_maximum
  step: 1, // @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#setting_the_values_granularity
};
